/* global __CONFIG__ */

import i18n from 'i18next';
import langDetector from 'i18next-browser-languagedetector';
import i18nextXHRBackend from 'i18next-xhr-backend';

import { languages, defaultLanguage } from './constants/languages';

import { setBodyLanguage } from '@snapask/common-components/services/language.js';

const whiteList = Object.keys(languages).map((key) => languages[key]);

i18n.use(langDetector).use(i18nextXHRBackend);

const config = {
  fallbackLng: defaultLanguage,
  whiteList,
  load: 'currentOnly', // only reading format: zh-TW, en-SG
  lowerCaseLng: true, // keep language format in lower case.
  defaultNS: 'coconut',
  ns: [
    // sort alphabeticaly
    'coconut',
    'sdk',
    'navigation',
  ],
  detection: {
    order: ['querystring', 'cookie', 'localStorage', 'htmlTag'], // we will try to read language set by dragonfruit
    lookupQuerystring: 'lng',
    lookupCookie: 'userLng',
    lookuplocalStorage: 'userLng',
    caches: ['localStorage', 'cookie'],
    cookieDomain: __CONFIG__.COOKIE_DOMAIN,
  },
  backend: {
    loadPath: '/i18n/{{lng}}/{{ns}}.json',
  },
  react: {
    wait: true,
  },
};

export default i18n.init(config, () => {
  setBodyLanguage(window, i18n.language);
});



// WEBPACK FOOTER //
// ./src/i18n.js